/**
 * SocialButton.js
 *
 * Created by Dennis Gecaj on 12/28/17
 *
 * @desc The social button is a presentational component.
 * @author Dennis Gecaj
 * @copyright © Yello Lab Inc. All rights reserved.
 * @version 1.0
 */

import PropTypes from 'prop-types';
import React from 'react';

import '../aboutCard/Styles.css';

const SocialButton = props => (
  <button className="SocialButtonComponent" onClick={() => props.action()}>
    <img className="SocialButtonComponent ImageTag" src={props.image} alt="Social" />
  </button>
);

SocialButton.defaultProps = {
  action: Function.prototype,
};

SocialButton.propTypes = {
  /** The action when clicking on the social button. */
  action: PropTypes.func,
  /** An image for the social button (e.g. twitter). */
  image: PropTypes.node.isRequired,
};

export default SocialButton;
